import { Helmet } from "react-helmet-async"
import { HotelsList } from "./../../../Hotels"

export default function Hotels() {
	return (
		<>
			<Helmet>
				<title>Hotels</title>
			</Helmet>
			<HotelsList />
		</>
	)
}
